import { useEffect, useState } from 'react'
import { buildActions, readAnchoredActionSet } from '../utils/aiAnalysis/draftPayload'
import { isDraftActionDecided } from '../models/aiAnalysis/workflow'
import type { DraftAction } from '../models/aiAnalysis/workflow'

const readPending = (): DraftAction[] => {
  const actionSet = readAnchoredActionSet()
  return actionSet ? buildActions(actionSet).filter((action) => !isDraftActionDecided(action)) : []
}

// The anchored payload is re-rendered by the server on every draft event;
// aiDraftPayloadRefreshed is the section partial's cue that it changed.
export const useAnchoredDraftActions = (): DraftAction[] => {
  const [actions, setActions] = useState<DraftAction[]>(readPending)

  useEffect(() => {
    const onRefresh = () => setActions(readPending())
    document.addEventListener('aiDraftPayloadRefreshed', onRefresh)
    return () => document.removeEventListener('aiDraftPayloadRefreshed', onRefresh)
  }, [])

  return actions
}
